import { render, staticRenderFns } from "./CharacterSheetModifier.vue?vue&type=template&id=0fef9ed0&lang=pug&"
import script from "./CharacterSheetModifier.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetModifier.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterSheetModifier.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports